import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ContactRelationTable from '@contacts/components/tables/contact-relation-table/contact-relation-table.vue';

@Component({
  name: 'bpc-contact-relations',
  components: {
    'bpc-contact-relation-table': ContactRelationTable,
  },
})
export default class ContactRelations extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
